const carouselItems = [
  {
    title: '国产口碑剧',
    subtitle: '《繁花》《狂飙》《漫长的季节》等高分神作',
    desc: '近年国产剧质量飞跃，从悬疑到年代剧全面开花，部部豆瓣8.5+分。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20cinematic%20landscape%20with%20Shanghai%20skyline%201990s%20retro%20atmosphere%2C%20warm%20golden%20evening%20light%2C%20film%20grain%20texture%2C%20elegant%20city%20architecture%2C%20nostalgic%20mood%2C%20cinematic%20color%20grading&width=800&height=400&seq=carousel-domestic&orientation=landscape',
    tag: '高分推荐',
  },
  {
    title: '韩剧精选馆',
    subtitle: '《黑暗荣耀》《财阀家的小儿子》现象级爆款',
    desc: '宋慧乔复仇爽剧到宋仲基豪门恩怨，韩流持续席卷全球。',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20cinematic%20scene%20with%20modern%20Seoul%20cityscape%2C%20dramatic%20moody%20lighting%2C%20rainy%20streets%2C%20neon%20signs%2C%20emotional%20atmosphere%2C%20film%20noir%20style%2C%20rich%20contrast%20and%20deep%20shadows&width=800&height=400&seq=carousel-korean&orientation=landscape',
    tag: '韩流热播',
  },
  {
    title: '悬疑烧脑专区',
    subtitle: '《他是谁》《尘封十三载》《白夜追凶》系列',
    desc: '烧脑剧情环环相扣，每一帧都不容错过，弹幕推理党狂欢。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20crime%20scene%20investigation%20atmosphere%20with%20dark%20alley%2C%20foggy%20night%2C%20police%20tape%2C%20silhouetted%20detective%20figure%2C%20rain-slicked%20pavement%2C%20noir%20lighting%2C%20tense%20moody%20cinematic%20photography&width=800&height=400&seq=carousel-suspense&orientation=landscape',
    tag: '烧脑必看',
  },
  {
    title: '美剧不剧荒',
    subtitle: '《最后生还者》《继承之战》艾美奖收割机',
    desc: 'HBO出品必属精品，顶级制作水准带来沉浸式观剧体验。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20American%20drama%20cinematic%20wilderness%20landscape%20with%20abandoned%20city%20overgrown%20by%20nature%2C%20golden%20hour%20light%2C%20solitary%20figure%20walking%2C%20post-apocalyptic%20beauty%2C%20film-grade%20color%20grading%2C%20atmospheric%20and%20emotional&width=800&height=400&seq=carousel-american&orientation=landscape',
    tag: 'HBO精品',
  },
  {
    title: '古装仙侠盛宴',
    subtitle: '《长相思》《玉骨遥》《莲花楼》国风美学巅峰',
    desc: '顶级服化道还原东方奇幻世界，每一帧都是壁纸级画面。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20landscape%20with%20floating%20mountains%2C%20misty%20waterfalls%2C%20traditional%20pavilions%2C%20cherry%20blossoms%2C%20golden%20sunlight%20rays%2C%20celestial%20atmosphere%2C%20oriental%20ink%20painting%20style%20with%20soft%20ethereal%20glow&width=800&height=400&seq=carousel-fantasy&orientation=landscape',
    tag: '国风美学',
  },
  {
    title: '经典重温时刻',
    subtitle: '《甄嬛传》《琅琊榜》《武林外传》百看不厌',
    desc: '那些年我们追过的神剧，每一遍都有新发现，弹幕常驻经典。',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20vintage%20film%20projector%20with%20warm%20glowing%20light%2C%20classic%20movie%20posters%20on%20wall%2C%20old%20cinema%20atmosphere%2C%20dust%20particles%20in%20light%20beam%2C%20warm%20sepia%20tones%2C%20retro%20movie%20theater%20interior%2C%20cozy%20and%20sentimental&width=800&height=400&seq=carousel-classic&orientation=landscape',
    tag: '经典必刷',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-500/10 border border-secondary-500/20 mb-4">
            <i className="ri-layout-masonry-line text-secondary-500 text-sm"></i>
            <span className="text-secondary-400 text-xs font-medium">专题精选</span>
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门专题聚焦</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">
            六大专题频道帮你快速定位感兴趣的类型，告别剧荒
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-100 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-500/20 transition-all cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="800"
                  height="400"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-background-100/20 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-accent-500 text-background-950 text-xs font-semibold">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h4 className="text-foreground-800 font-heading font-bold text-sm mb-1.5">{item.title}</h4>
                <p className="text-foreground-400 text-xs mb-2">{item.subtitle}</p>
                <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}